export class BIM360IssueRootCauseCategories
{
    public id: string = '';
    public title: string = '';;
    public isActive: boolean = false;
    public rootCauses: BIM360IssueRootCauseV2[] = [];

    public static fromAutodeskJSON(json: any): BIM360IssueRootCauseCategories
    {
        let rootCauseCategories = new BIM360IssueRootCauseCategories();
        rootCauseCategories.id = json.id;
        rootCauseCategories.isActive = json.isActive;
        rootCauseCategories.title = json.title;
        rootCauseCategories.rootCauses = json.rootCauses.map((sub) => BIM360IssueRootCauseV2.fromAutodeskJSON(sub)); 
        return rootCauseCategories;
    }
}

export class BIM360IssueRootCauseV2 
{
    public id: string = '';
    public title: string = '';;
    public isActive: boolean = false;
    public rootCauseCategoryId: string = "";
    public rootCauses: BIM360IssueRootCauseV2[] = [];

    public static fromAutodeskJSON(json: any): BIM360IssueRootCauseV2
    {
        const rootCause = new BIM360IssueRootCauseV2();
        rootCause.id = json.id;
        rootCause.isActive = json.isActive;
        rootCause.rootCauseCategoryId = json.rootCauseCategoryId;
        rootCause.title = json.title
        return rootCause
    }
}